
























































import { Component, Vue, Prop } from 'vue-property-decorator'
import SettingsCard from '@/components/WorkspaceSettings/SettingsCard.vue'
import { Button } from '@alpha/ink'
import AjaxButton from '@/components/AjaxButton.vue'
import ConfirmationMessage from '@/components/WorkspaceSettings/ConfirmationMessage.vue'
import { SettingsSubmissionData, SettingsSubmissionResponse, SettingsConfirmation, SlackIntegrationBlob, SlackClientConfig } from '@/views/WorkspaceSettings.vue'
import SlackIcon from '@/assets/img/slack-icon.png'

@Component({
  name: 'SlackSettings',
  components: { ConfirmationMessage, AjaxButton, SettingsCard, Button }
})
export default class SlackSettings extends Vue {
  @Prop({ required: true }) slackIntegration!: SlackIntegrationBlob
  @Prop({ required: true }) slackClientInfo!: SlackClientConfig
  confirmation: SettingsConfirmation = {
    status: false,
    msg: ''
  }

  slackIcon: string = SlackIcon
  submitting: boolean = false

  addToSlack () {
    window.location.href = `https://slack.com/oauth/authorize?scope=incoming-webhook&state=${this.slackIntegration.state}&client_id=${this.slackIntegration.id}`
  }

  submit () {
    if (!this.submitting) {
      this.confirmation.status = false
      this.submitting = true
      const submitObj: SettingsSubmissionData = {
        component: this,
        section: 'revoke-slack',
        data: {}
      }
      this.$emit('submit', submitObj)
    }
  }

  finish (confirmation: SettingsSubmissionResponse) {
    const that = this
    this.confirmation = confirmation
    this.submitting = false;
    (this.$refs.saveButton as AjaxButton).finish()
    if (confirmation.status !== 'failure') {
      setTimeout(function () {
        that.$set(that.confirmation, 'status', false)
      }, 3000)
    }
  }
}
